/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import BasicDialog from "../../Shared/Dialogs/BasicDialog";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import TemplateTable from "./TemplateTable";
import { Button } from "../../ui/button";

interface IAddCommissioningProps {
  modelOpenMode?: string;
}

const AddEditLanDevice: React.FC<IAddCommissioningProps> = ({ modelOpenMode = "Apply" }) => {
  const dispatch = useStoreDispatch();


  const dialogAction = (
    <div className="flex justify-end items-center pt-2 pb-2 mr-5">
      <Button
        variant="outline"
        onClick={() => dispatch(setBasicDialogOpenFor(undefined))}
      >
        Cancel
      </Button>
    </div>
  );

  return (
    <BasicDialog size="md" headerTitle={`${modelOpenMode} Templates`} dialogActions={dialogAction}>
      <div className="mx-4">
        <TemplateTable templateType="Apply" />
      </div>
    </BasicDialog>
  );
};

export default AddEditLanDevice;